import { SIZE } from '@app/src/ui';
import styled from 'styled-components';

export const FooterWrapper = styled.div`
  position: static;
  width: 100%;
  bottom: 0;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    position: absolute;
  }
`;